define('shared/initializer/form/adapters/mixins/MixinSwitchable',[
    'Promise'
], function (
    Promise
) {
    'use strict';

    function create(Controller, MixinA, MixinB) {
        function Ctor() { 
            var me = this;

            me.args = {};
            me.currentMixinVersion = 'A';
            me.buffer = [];
            me.on('mixin.switchable.switch', function(result){
                if (!result || typeof result !== 'string') {
                    return;
                }

                var promise = Promise.resolve();
                me.block();

                if (me.currentMixinVersion !== result.toUpperCase()) {
                    me.currentMixinVersion = result.toUpperCase();
                    
                    for (var i = 0; i < me.buffer.length; i++) {
                        var bufferedLifeCycle = me.buffer[i];
                        promise = promise.then(function() {
                            return Promise.resolve(
                                bufferedLifeCycle.func.apply(me, me.args[bufferedLifeCycle.name])
                            );
                        });
                    }
                }

                promise.then(function(){
                    me.resume();
                }, function() {
                    me.resume();
                });
            });

            function ProxyMixin() {
                MixinA.call(this);
                MixinB.call(this);
            }

            for(var i = 0; i < this.lifeCycles.length; i++ ) (function(lifeCycleName){
                ProxyMixin.prototype[lifeCycleName] = function(data) {
                    var a = MixinA.prototype[lifeCycleName];
                    var b = MixinB.prototype[lifeCycleName];
                    var ret = data;
                    var toCall, toBuffer;

                    me.args[lifeCycleName] = arguments;

                    if (me.currentMixinVersion === 'A') {
                        toCall = a;
                        toBuffer = b;
                    } else {
                        toCall = b;
                        toBuffer = a;
                    }

                    if (toCall) {
                        ret = toCall.apply(this, arguments);
                    }

                    if (toBuffer) {
                        me.buffer.push({
                            name: lifeCycleName,
                            func: toBuffer
                        });
                    }

                    return ret;
                };
            })(this.lifeCycles[i]);

            this.mixin(ProxyMixin, Controller);
        }

        return Ctor;
    }

    return create;
});
